// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__392sK","content":"RecentSearches_content__3uo95"};